module.exports = __webpack_public_path__ + "static/media/agendas.3c61740a.png";